<template>
  <MobileLayerEditor v-if="mode === 'mobile'">
    <slot></slot>
  </MobileLayerEditor>
  <ScreenLayerEditor v-else>
    <slot></slot>
  </ScreenLayerEditor>
</template>
<script>
import MobileLayerEditor from './mobile'
import ScreenLayerEditor from './screen'
export default {
  name: 'ICEditor',
  components: {
    MobileLayerEditor,
    ScreenLayerEditor
  },
  inject: ['mode']
}
</script>
